const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const fetchSummaryofSummaries = async (patient_id) => {
  const response = await fetch(`${BACKEND_URL}/api/summary-of-summary/${patient_id}`);
  if (!response.ok) {
    throw new Error('Failed to fetch summary');
  }
  return response.json();
}
